import React, { useEffect } from "react";
import { Grid, Card, CardContent, Divider } from "@mui/material";
import Label from "../../../components/Label/Label";
import "./newTaskStatus.scss";

import { useDispatch, useSelector } from "react-redux";
import { getTotalProjectsAndBatchesWithStatusCount } from "../../../redux/investigation/actions";

import BatchStatusCard from "./BatchStatusCard";
import ProductCard from "./ProductCard";
import BatchTiles from "./BatchTiles";

const Dashboard = () => {
  const dispatch = useDispatch();

  const projectsAndBatchesWithStatusCounts = useSelector(
    (state) => state?.investigation?.projectsAndBatchesWithStatusCounts
  );

  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(getTotalProjectsAndBatchesWithStatusCount());
  }, [dispatch]);

  return (
    <div style={{ padding: "15px" }}>
      <Grid container spacing={2} xs={12}>
        <Grid item xs={2} sm={6} md={2.4}>
          <Card variant="outlined" className="weidget-count-card-box">
            <CardContent className="flex-row-center">
              <div style={{ width: "60%" }}>
                <Label
                  text="Number Of Products"
                  fontSize="14px"
                  fontWeight="700"
                />
              </div>
              <div style={{ width: "40%" }}>
                <Label
                  text={projectsAndBatchesWithStatusCounts?.total_products}
                  fontSize="40px"
                  fontWeight="800"
                  textAlign="center"
                />
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={2} sm={3} md={2.4}>
          <Card variant="outlined" className="weidget-count-card-box">
            <CardContent className="flex-row-center">
              <div style={{ width: "60%" }}>
                <Label
                  text="Number Of Templates"
                  fontSize="14px"
                  fontWeight="700"
                />
              </div>
              <div style={{ width: "40%" }}>
                <Label
                  text={
                    projectsAndBatchesWithStatusCounts?.total_templates_count
                  }
                  fontSize="40px"
                  fontWeight="800"
                  textAlign="center"
                />
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={2} sm={3} md={2.4}>
          <Card variant="outlined" className="weidget-count-card-box">
            <CardContent className="flex-row-center">
              <div style={{ width: "60%" }}>
                <Label
                  text="Number Of Batches Received"
                  fontSize="14px"
                  fontWeight="700"
                />
              </div>
              <div style={{ width: "40%" }}>
                <Label
                  text={
                    projectsAndBatchesWithStatusCounts?.total_batches_received
                  }
                  fontSize="40px"
                  fontWeight="800"
                  textAlign="center"
                />
              </div>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={2} sm={3} md={2.4}>
          <Card variant="outlined" className="weidget-count-card-box">
            <CardContent className="flex-row-center">
              <div style={{ width: "60%" }}>
                <Label
                  text="Batch Under Process"
                  fontSize="14px"
                  fontWeight="700"
                />
              </div>
              <div style={{ width: "40%" }}>
                <Label
                  text={
                    projectsAndBatchesWithStatusCounts?.batches_under_process
                  }
                  fontSize="40px"
                  fontWeight="800"
                  textAlign="center"
                />
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={2} sm={3} md={2.4}>
          <Card variant="outlined" className="weidget-count-card-box">
            <CardContent className="flex-row-center">
              <div style={{ width: "60%" }}>
                <Label
                  text="Batch Completed"
                  fontSize="14px"
                  fontWeight="700"
                />
              </div>
              <div style={{ width: "40%" }}>
                <Label
                  text={projectsAndBatchesWithStatusCounts?.batches_completed}
                  fontSize="40px"
                  fontWeight="800"
                  textAlign="center"
                />
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid container spacing={2} xs={12} sx={{ padding: "15px 0px 15px 0px" }}>
        <Grid item xs={2} sm={2} md={5}>
          <ProductCard />
        </Grid>
        <Grid item xs={2} sm={4} md={7}>
          <BatchStatusCard />
        </Grid>
      </Grid>

      <Divider />

      <BatchTiles />
    </div>
  );
};

export default Dashboard;
